import Burger from "./Burger";

export default Burger;